import { TReduxActions } from '../../types/redux';
import { IVacanciesState } from '../../types/vacancies';
import { EVacanciesActionTypes } from '../../actions/vacancies';

const defaultVacanciesState: IVacanciesState = {
  isLoading: false,
  isError: false,
  selectedFilters: {},
  vacanciesGroup: undefined,
};

export function vacanciesReducer(
  state: IVacanciesState = defaultVacanciesState,
  { type, payload }: TReduxActions,
): IVacanciesState {
  switch (type) {
    case EVacanciesActionTypes.RequestVacancies:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case EVacanciesActionTypes.RequestVacanciesError:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case EVacanciesActionTypes.SetVacanciesGroups:
      return {
        ...state,
        vacanciesGroup: payload,
        isLoading: false,
      };
    case EVacanciesActionTypes.SetVacancy:
      return {
        ...state,
        vacancy: payload,
      };
    case EVacanciesActionTypes.SetFilters:
      return {
        ...state,
        filters: payload,
      };
    case EVacanciesActionTypes.SetSelectedFilters:
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          [payload.filterName]: payload.selectedOptions,
        },
      };
    case EVacanciesActionTypes.ResetFilters:
      // eslint-disable-next-line no-case-declarations
      const updatedSelectedFilters = payload ? { ...state.selectedFilters, [payload]: [] } : {};

      return {
        ...state,
        selectedFilters: { ...updatedSelectedFilters },
      };

    default:
      return state;
  }
}
